export const minimumVersion = 582000;//兜底版本


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/notice_coupon_selected/config.js